// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"656":"profiler","952":"recorder"}[chunkId] + "." + {"656":"2052b01e","952":"af2cf69d"}[chunkId] + ".chunk.js";
};